// extracted by mini-css-extract-plugin
module.exports = {"btn":"BalanceForm_btn__TfQCL"};